import React from 'react';

const MyBookins = () => {
    return (
        <>

            my Bookings
        </>
    );
};

export default MyBookins;